"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.themeBerlitzOverride = void 0;
var _polished = require("polished");
var _icons = require("./config/icons");
var _sizing = require("./config/sizing");
var _animation = _interopRequireDefault(require("./config/animation"));
var _breakpoints = _interopRequireDefault(require("./config/breakpoints"));
var _colors = _interopRequireWildcard(require("./config/colors"));
var _elevation = _interopRequireDefault(require("./config/elevation"));
var _flexboxgrid = _interopRequireDefault(require("./config/flexboxgrid"));
var _typography = require("./config/typography");
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var themeBerlitzOverride = function themeBerlitzOverride() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var iconColors = _objectSpread(_objectSpread({}, _icons.iconColors), overrides.iconColors);
  var iconSizes = _objectSpread(_objectSpread({}, _icons.iconSizes), overrides.iconSizes);
  var layout = _objectSpread(_objectSpread({}, _sizing.layout), overrides.layout);
  var space = _objectSpread(_objectSpread({}, _sizing.space), overrides.space);
  var radius = _objectSpread(_objectSpread({}, _sizing.radius), overrides.radius);
  var animation = _objectSpread(_objectSpread({}, _animation.default), overrides.animation);
  var breakpoints = _objectSpread(_objectSpread({}, _breakpoints.default), overrides.breakpoints);
  var colors = _objectSpread(_objectSpread({}, _colors.default), overrides.colors);
  var palette = _objectSpread(_objectSpread({}, _colors.palette), overrides.palette);
  var elevation = _objectSpread(_objectSpread({}, _elevation.default), overrides.elevation);
  var flexboxgrid = _objectSpread(_objectSpread({}, _flexboxgrid.default), overrides.flexboxgrid);
  var typography = _objectSpread(_objectSpread({}, _typography.typography), overrides.typography);
  var fontSize = _objectSpread(_objectSpread({}, _typography.fontSize), overrides.fontSize);
  var fontWeight = _objectSpread(_objectSpread({}, _typography.fontWeight), overrides.fontWeight);
  var lineHeight = _objectSpread(_objectSpread({}, _typography.lineHeight), overrides.lineHeight);
  var letterSpacing = _objectSpread(_objectSpread({}, _typography.letterSpacing), overrides.letterSpacing);
  return {
    name: 'Berlitz',
    // Globals
    animation: animation,
    breakpoints: breakpoints,
    colors: colors,
    elevation: elevation,
    iconColors: iconColors,
    iconSizes: iconSizes,
    layout: layout,
    space: space,
    radius: radius,
    typography: typography,
    fontSize: fontSize,
    fontWeight: fontWeight,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing,
    // Grid
    flexboxgrid: flexboxgrid,
    // Components
    breadcrumbs: {
      currentPageItemColor: colors.text00,
      fontSize: fontSize.xxs,
      fontSizeDesktop: '15px',
      linkColor: colors.text02,
      linkColorHover: colors.brandSecondary,
      dividerColor: colors.text00
    },
    button: {
      ghostBorderColor: colors.ui00,
      ghostTextColor: colors.ui00,
      borderRadius: '3px',
      fontSize: fontSize.xxs,
      fontWeight: fontWeight.bold,
      lineHeight: lineHeight.md,
      padding: "".concat(space.sm, " ").concat(space.lg),
      paddingSmall: "".concat(space.xxs, " ").concat(space.xs),
      textColor: colors.brandPrimaryContrast,
      backgroundColorHover: colors.brandPrimaryInteract,
      ghostBorderSize: '2px',
      // default
      defaultBackgroundColor: colors.brandPrimary,
      defaultTextColor: colors.brandPrimaryContrast,
      defaultBackgroundColorHover: colors.brandPrimaryInteract,
      disabledSecondaryColor: colors.ui05,
      // info
      infoBackgroundColor: colors.uiInfo,
      infoTextColor: colors.uiInfoContrast,
      infoBackgroundColorHover: colors.uiInfoInteract,
      // warning
      warningBackgroundColor: colors.uiWarning,
      warningTextColor: colors.uiWarningContrast,
      warningBackgroundColorHover: colors.uiWarningInteract,
      // error
      errorBackgroundColor: colors.uiError,
      errorTextColor: colors.uiErrorContrast,
      errorBackgroundColorHover: colors.uiErrorInteract,
      //success
      successBackgroundColor: colors.uiSuccess,
      successTextColor: colors.uiSuccessContrast,
      successBackgroundColorHover: colors.uiSuccessInteract,
      //light
      lightBackgroundColor: colors.ui01,
      lightTextColor: colors.text00,
      lightBackgroundColorHover: colors.ui04
    },
    card: {
      borderRadius: radius.md,
      backgroundColor: colors.ui00,
      headingColor: colors.text00,
      boxShadow: elevation.sm,
      boxShadowHover: elevation.lg,
      activeTransform: "translateY(-".concat(space.xxs, ")"),
      transition: animation.transitionSlow,
      imageRatio: '60%',
      rowImageHeightDefault: '260px',
      rowImageHeightLarge: '340px'
    },
    checkbox: {
      border: "1px solid ".concat(colors.ui04),
      borderRadius: radius.md,
      color: colors.ui00,
      colorChecked: colors.brandPrimary,
      tickColor: colors.brandPrimaryContrast,
      size: '20px',
      transition: animation.transitionMedium,
      labelMargin: space.md
    },
    datepicker: {
      navArrowSize: '8px'
    },
    expander: {
      borderBottom: "1px solid ".concat(colors.ui02),
      iconMarginRight: space.md,
      transition: animation.transitionMedium
    },
    formField: {
      spacing: space.sm,
      labelColor: colors.text00,
      labelColorLight: colors.text03,
      requiredAsteriskColor: colors.uiError,
      requiredAsteriskColorLight: colors.text03,
      validationBackground: colors.ui00,
      validationBorder: "1px solid ".concat(colors.ui02),
      validationBorderRadius: radius.sm,
      validationBoxShadow: elevation.sm,
      validationFontSize: fontSize.xs,
      validationFontWeight: fontWeight.bold,
      validationIconColor: colors.uiWarning,
      validationMinHeight: space.xl,
      validationPadding: space.xs,
      validationTextColor: colors.text01
    },
    input: {
      backgroundColor: colors.ui00,
      border: "1px solid ".concat(colors.ui04),
      borderRadius: radius.sm,
      fontSize: fontSize.xs,
      lineHeight: lineHeight.md,
      padding: space.sm,
      textColor: colors.text01,
      textColorDisabled: colors.text02,
      backgroundColorDisabled: colors.ui02,
      backgroundColorDisabledLight: colors.ui04,
      borderBottomGhost: "1px solid ".concat(colors.ui03),
      buttonWidth: space.xxl,
      placeholderColor: colors.textMuted
    },
    levelChart: {
      titleBg: colors.brandSecondary,
      titleColor: colors.brandSecondaryContrast,
      chartBg: colors.ui02,
      barColors: {
        default: {
          bgColor: palette.blue100,
          textColor: palette.white
        },
        active: {
          bgColor: palette.green90,
          textColor: palette.charcoal
        },
        1: {
          bgColor: palette.blue10,
          textColor: palette.charcoal
        },
        2: {
          bgColor: palette.blue20,
          textColor: palette.charcoal
        },
        3: {
          bgColor: palette.blue30,
          textColor: palette.charcoal
        },
        4: {
          bgColor: palette.blue40,
          textColor: palette.charcoal
        },
        5: {
          bgColor: palette.blue50,
          textColor: palette.white
        },
        6: {
          bgColor: palette.blue60,
          textColor: palette.white
        },
        7: {
          bgColor: palette.blue70,
          textColor: palette.white
        },
        8: {
          bgColor: palette.blue80,
          textColor: palette.white
        },
        9: {
          bgColor: palette.blue90,
          textColor: palette.white
        },
        10: {
          bgColor: palette.blue100,
          textColor: palette.white
        }
      }
    },
    logo: {
      color: colors.brandPrimary
    },
    modal: {
      boxShadow: elevation.lg,
      modalInnerColor: colors.ui00,
      modalPadding: space.xl,
      modalWidth: breakpoints.sm,
      overlayColorDesktop: colors.ui05,
      overlayColorMobile: 'transparent',
      radius: radius.md,
      topBarColor: colors.ui00,
      topBarShadow: elevation.sm,
      topBarSizeDesktop: layout.md,
      topBarSizeMobile: layout.lg
    },
    pageBanner: {
      overlayColor: colors.ui05
    },
    section: {
      backgroundColor: {
        ui00: colors.ui00,
        ui01: colors.ui01,
        ui02: colors.ui02,
        ui03: colors.ui03,
        ui04: colors.ui04,
        ui05: colors.ui05,
        brandPrimary: colors.brandPrimary,
        brandSecondary: colors.brandSecondary,
        charcoal: colors.brandSupporting01,
        purple: colors.brandSupporting03,
        default: colors.ui00
      }
    },
    select: {
      backgroundColor: colors.ui00,
      border: "1px solid ".concat(colors.ui04),
      borderRadius: radius.sm,
      fontSize: fontSize.xs,
      lineHeight: lineHeight.md,
      padding: space.sm,
      textColor: colors.text01,
      paddingRight: "".concat((0, _polished.stripUnit)(iconSizes.sm) + (0, _polished.stripUnit)(space.sm), "px"),
      textColorDisabled: colors.text02,
      backgroundColorDisabled: colors.ui02,
      backgroundColorDisabledLight: colors.ui04,
      borderBottomGhost: "1px solid ".concat(colors.ui03),
      placeholderColor: colors.textMuted
    },
    spinner: {
      color: colors.brandPrimary
    },
    subFooter: {
      backgroundColor: colors.ui02,
      textColor: colors.text01,
      fontSize: fontSize.xxs,
      padding: space.md
    },
    testimonials: {
      dotColor: colors.ui04,
      dotColorActive: colors.brandPrimary,
      maxWidth: breakpoints.md,
      imageSizeMobile: layout.xxl,
      imageSizeDesktop: layout.xxl
    },
    textArea: {
      backgroundColor: colors.ui00,
      border: "1px solid ".concat(colors.ui04),
      borderRadius: radius.sm,
      fontSize: fontSize.xs,
      padding: space.sm,
      textColor: colors.text01,
      textColorDisabled: colors.text02,
      backgroundColorDisabled: colors.ui02,
      borderBottomGhost: "1px solid ".concat(colors.ui03),
      placeholderColor: colors.textMuted
    },
    topNav: {
      mobile: {
        barHeight: layout.lg,
        boxShadow: elevation.sm,
        hamburgerMenuColor: colors.brandPrimary,
        menuBackgroundColor: colors.ui00,
        navItemFontSize: fontSize.sm,
        navItemFontWeight: fontWeight.semiBold,
        navItemColor: colors.text01,
        navItemPadding: "".concat(space.md, " ").concat(space.lg),
        subItemIndentLeft: space.lg,
        subItemFontSize: fontSize.xs,
        subItemFontWeight: fontWeight.semiBold,
        subItemBackgroundColor: colors.ui01,
        toggleDuration: animation.duration.mediumSlow,
        animationAxis: 'X'
      },
      desktop: {
        fontSize: fontSize.xs,
        fontSizeSmall: fontSize.xxs,
        lineHeight: lineHeight.lg,
        fontWeight: fontWeight.semiBold,
        textColor: colors.text03,
        textColorInverse: colors.text01,
        stickyNavBackgroundColor: colors.ui00,
        stickyNavBoxShadow: elevation.lg,
        stickyNavPadding: space.sm,
        logoPadding: space.md,
        dropDownBackgroundColor: colors.ui00,
        dropDownBorderRadius: radius.md,
        dropDownTextColor: colors.text01,
        dropDownTextColorHover: colors.brandPrimary,
        dropDownBorderColor: colors.ui02,
        dropDownBoxShadow: elevation.lg,
        dropDownPadding: "".concat(space.sm, " ").concat(space.lg)
      }
    },
    gridWidth: flexboxgrid.width,
    palette: palette
  };
};
exports.themeBerlitzOverride = themeBerlitzOverride;
var _default = themeBerlitzOverride();
exports.default = _default;